import React from 'react';
import { Row } from 'antd';

/**
 * Container
 * --
 */
const Container = ({
  justify = 'start', // ['center','start','end']
  gutter = [0, 0],
  style = {},
  padding = null,
  children,
}) => {
  /* Render */
  return (
    <Row
      justify={justify}
      style={{
        marginRight: 0,
        marginLeft: 0,
        ...style,
        ...(padding && { padding }),
      }}
      gutter={gutter}
    >
      {children}
    </Row>
  );
};

export default Container;
